import { render, staticRenderFns } from "./NotificationListPage.vue?vue&type=template&id=cacaf13c&"
import script from "./NotificationListPage.vue?vue&type=script&lang=js&"
export * from "./NotificationListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports